module.exports = __webpack_public_path__ + "static/media/datacamp.ecd049cf.png";